import React from 'react'
import iconOne from 'assets/icon-number-1.svg'
import iconTwo from 'assets/icon-number-2.svg'
import iconThree from 'assets/icon-number-3.svg'
import styles from './FooterBlock.module.css'

export type FooterBlockNumber = 'one' | 'two' | 'three'

const ICONS: Record<FooterBlockNumber, string> = {
  one: iconOne,
  two: iconTwo,
  three: iconThree,
}

type FooterBlockProps = {
  title: string,
  content: string,
  type: FooterBlockNumber,
}

/** One numbered block above the footer menu; texts come from site settings */
export const FooterBlock: React.FC<FooterBlockProps> = (props) => {
  const { title, content, type } = props
  return (
    <div className={styles.container}>
      <div className={styles.contentBlock}>
        <img className={styles.icon} src={ICONS[type]} alt="icon" />
        <div className={styles.title}>{title}</div>
        <div className={styles.secondText}>{content}</div>
      </div>
    </div>
  )
}
